import React from "react";
import IndustrialEntry from "../components/IndustrialEntry";

export default function IndustrialSale() {
  return <IndustrialEntry type="sale" />;
}
